module.exports = __webpack_public_path__ + "static/media/chatedio-horizontal-icon.16c42dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chatedio-horizontal-icon.png
// module id = 1347
// module chunks = 0